export default __webpack_public_path__ + "static/media/HDTX_LKTT 2020.8c7f26ef.pdf";